import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container, Table } from "react-bootstrap";
import { connect } from "react-redux";
import { AddDocumentTypeApi, GetDocumentTypeApi } from "./JobAction";
import { setHeading } from "../../../accounts/account.actions";
import _ from "lodash";
import { GlobalSpinner } from "../../../../../global/globalFunctions";
import Swal from "sweetalert";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import moment from "moment";


const AddDocumentType = (props) => {
    const [documentName, setDocumentName] = useState("");
    const [description, setDescription] = useState("");
    const [visibleAlert, setAlertVisible] = useState(false);
    const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);

    useEffect(() => {
        props.setHeading("Add Document Type");
        props.GetDocumentTypeApi();
    }, []);


    function SaveDocumentType() {
        props.AddDocumentTypeApi({
            documentName: documentName,
            description: description,
        },
            handleVisible,
            handleDangerVisible
        );
        setDocumentName("");
        setDescription("");
    }
    const handleVisible = (msg) => {
        setAlertVisible(true);
        setTimeout(() => {
            setAlertVisible(false);
        }, 9000);
        Swal({
            title: "Success",
            text: msg,
            icon: "success",
            button: "Ok",
        });
    };
    const handleDangerVisible = (err) => {
        setDangerVisibleAlert(true);
        setTimeout(() => {
            setDangerVisibleAlert(false);
        }, 9000);
        Swal({
            title: "Error",
            text: err,
            icon: "error",
            button: "Ok",
        });
    };

    return (
        <>
            {props.isAddingDocumentType || props.isFetchingDocumentType ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Form>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Document Name *</b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Document Name"
                                        value={documentName}
                                        onChange={(e) => setDocumentName(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Description </b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Description"
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <div className="sendDiv">
                            {_.isEmpty(documentName) ? (
                                <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
                            ) : (
                                <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SaveDocumentType}> SAVE </Button>
                            )}
                        </div>
                    </Form>

                    <div className="mt-5">
                        <h4>Existing Document Types</h4>
                        {props.documentTypeList.length === 0 ? (
                            <p>No document types found. Add one above.</p>
                        ) : (
                            <Table striped bordered hover responsive>
                                <thead>
                                    <tr>
                                        <th>Sr.No #</th>
                                        <th>Document Name</th>
                                        <th>Description</th>
                                        <th>Created Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.documentTypeList.map((docType, index) => (
                                        <tr key={docType.id || index}>
                                            <td>{docType.sequenceNumber}</td>
                                            <td>{docType.documentName}</td>
                                            <td>{docType.description || ''}</td>
                                            <td>{moment(docType.createdAt).format('DD-MM-YYYY')}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        )}
                    </div>
                </Container>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        AddDocumentTypeApi: (data, handleVisible, handleDangerVisible) => dispatch(AddDocumentTypeApi(data, handleVisible, handleDangerVisible)),
        GetDocumentTypeApi: () => dispatch(GetDocumentTypeApi()),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};

const mapStateToProps = (state, ownProps) => ({
    isAddingDocumentType: state.JobReducer.isAddingDocumentType,
    isFetchingDocumentType: state.JobReducer.isFetchingDocumentType,
    documentTypeList: state.JobReducer.documentTypeList,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddDocumentType);